import styled from 'styled-components';
import Column from '@sdk/components/ui/spacing/Column';
import Row from '@sdk/components/ui/spacing/Row';

export const AddCommentColumn = styled(Column)`
  flex: 1;
`;

export const EditIconContent = styled(Row)`
  display: none;
`;

export const EditIconSpacer = styled(Row)`
  height: 24px;
  width: 34px;
`;

export const CommentContent = styled(Row)`
  padding: 5px;
  border: 1px solid transparent;
  justify-content: space-between;

  &:hover {
    cursor: pointer;
    background-color: ${({ theme }) => theme.colors.hoverDarker};
    border: 1px solid ${({ theme }) => theme.colors.separatorOnGray};

    ${EditIconContent} {
      display: flex;
    }

    ${EditIconSpacer} {
      display: none;
    }
  }
`;

export const CommentInnerContent = styled(Row)`
  word-wrap: break-word;
  word-break: break-all;
  white-space: normal;
  max-width: 384px;
`;
